import { render } from "./_PageResult.vue?vue&type=template&id=01118090&ts=true"
import script from "./_PageResult.vue?vue&type=script&lang=ts"
export * from "./_PageResult.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Hirofumi\\repository\\suite_totalling\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__